import type { ReactNode } from "react";

/** Flex column shell for hub pages — table fills remaining viewport height. */
export const LIST_PAGE_CLASS = "flex min-h-0 flex-1 flex-col gap-4";

export function ListPageShell({ children }: { children: ReactNode }) {
  return <div className={LIST_PAGE_CLASS}>{children}</div>;
}
